import { estruturaItensMap } from '../risrotEstruturaCatalog';
import RisrotEstruturaTable from './RisrotEstruturaTable';
import type { RisrotEstruturaBaseProps } from './RisrotEstruturaTable';

const ESTRUTURA = 'Ombreira Esquerda' as const;

export default function EstruturaOmbreiraEsquerda(props: RisrotEstruturaBaseProps) {
	return (
		<RisrotEstruturaTable
			{...props}
			structureName={ESTRUTURA}
			fixedItems={estruturaItensMap[ESTRUTURA]}
		/>
	);
}
